import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './global.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';

// Dynamically import buildInfo if it exists, otherwise use fallback
let buildInfo = { buildId: 'development', timestamp: new Date().toISOString(), version: '3.10.4' };
try {
  buildInfo = require('./buildInfo.json');
} catch (e) {
  console.warn('buildInfo.json not found, using fallback');
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Make sure there is an element with id="root" in your HTML.');
}

console.log(`TCG Calendar Australia - Build: ${buildInfo.buildId}`);

// Public routes can contain a useful build-time shell. This application is not
// server-rendered, so createRoot replaces that shell on its first commit. Let
// React schedule the commit normally: the static content remains visible until
// the live app is ready, and the initial render is not forced into one long
// blocking task.
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Register service worker only in production to avoid dev auto-refresh issues
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    const buildId = buildInfo.buildId || 'production';

    window.addEventListener('load', () => {
      const swUrl = `/sw.js?v=${encodeURIComponent(buildId)}`;

      navigator.serviceWorker.register(swUrl)
        .then((registration) => {
          registration.update();
          if (registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          }
          console.log('SW registered: ', registration);
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  } else {
    // Ensure any previously registered service workers and caches are cleared during development
    const cleanupDevArtifacts = async () => {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
      } catch (error) {
        console.log('SW cleanup failed: ', error);
      }

      if ('caches' in window) {
        try {
          const keys = await caches.keys();
          await Promise.all(keys.map((key) => caches.delete(key)));
        } catch (cacheError) {
          console.log('Cache cleanup failed: ', cacheError);
        }
      }
    };

    cleanupDevArtifacts();
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
